import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer>
    </footer>
  );
};

export default Footer;
